import { User } from './user.model';

/**
 * Represents the user devices data and associated metadata.
 */
export interface UserDevice {
    id?: string;
    userId: string;
    deviceId: string;
    deviceToken: string;
    platform: DevicePlatform;
    deviceModel?: string;
    deviceModelDisplay?: string;
    registeredAt: string;
    lastTokenRefresh: string;
    user?: User;
    tenantId?: string;
    branchId?: string;
}

/**
 * Represents the platform of a device with predefined constant values.
 */
export enum DevicePlatform {
    iOS = 1,
    Android = 2,
}
